export const radToDegFormatter = (rad: number) => {
  return ((rad / Math.PI) * 180).toFixed(1);
};
